/**
 * The one place that turns species data into "how much space does this habitat need".
 * Planet Zoo 2 rule (Zoopedia): a minimum for the first animal plus a fixed amount per additional animal.
 * The plan's extra-space setting (FD §4, default 25%) is added on top.
 */
import type { SpaceNeed, Species } from './types';

/** Space in m² for `count` animals under the game's rule (0 for no animals). */
export function spaceFor(need: SpaceNeed, count: number): number {
  if (count <= 0) return 0;
  return need.min + need.perExtra * (count - 1);
}

/** What a zone with `count` animals of `species` needs, including the plan's extra space (percent). */
export function speciesNeeds(species: Species, count: number, extraSpacePct: number): { area: number; water: number } {
  const f = 1 + extraSpacePct / 100;
  return { area: spaceFor(species.area, count) * f, water: spaceFor(species.water, count) * f };
}
